import { useContext } from "react";
import { PrimeToastContext } from "../common/toast-provider";

const useToast = () => {
  const ctx = useContext(PrimeToastContext);
  if (!ctx) throw new Error("useToast must be used within PrimeToastProvider");
  return ctx;
};

export default useToast;
